import React from "react";

export default function PgRuleNotAllowed({ PropertyObject }) {

  const [rules, setRules] = React.useState([]);

  React.useEffect(() => {
    const rulesnotallowed = PropertyObject?._lstPGRuleNotAllowed || [];
    const itemsPerGroup = Math.ceil(rulesnotallowed.length / 3);
    const groupedRules = [
      rulesnotallowed.slice(0, itemsPerGroup),
      rulesnotallowed.slice(itemsPerGroup, itemsPerGroup * 2),
      rulesnotallowed.slice(itemsPerGroup * 2)
    ];

    
    setRules(groupedRules);
  }, [PropertyObject]);

  return (
    <>
      {PropertyObject?._lstPGRuleNotAllowed?.length > 0 && (
        <>
          <h5 className="title fw-6">PG Rules : Not Allowed</h5>
          <div className="wrap-feature">
            {rules.map((rule, index) => (
              <div className="box-feature" key={index}>
                <ul>
                  {rule.map((item, idx) => (
                    <li className="feature-item" key={idx}>
                      {item.RuleName}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
